import axios from "axios";
import store from "../store";
import { message } from "antd";
import { signOut } from "store/slices/authSlice";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { API_BASE_URL } from "configs/AppConfig";

const axiosInterceptor = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000
});

const notificationMessageStatus = {
  400: "PROCESSING ERROR",
  401: "UNAUTHORIZED",
  404: "NOT FOUND",
  500: "INTERNAL SERVER ERROR",
  504: "REQUEST TIME OUT"
};
const TOKEN_PAYLOAD_KEY = "authorization";

const getLocation = async () => {
  let result = false;
  if ("geolocation" in navigator) {
    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

      const locationData = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      };

      if (locationData.latitude && locationData.longitude) {
        result = true;
      }
    } catch (error) {
      console.error("Error getting location:", error);
    }
  } else {
    console.log("Geolocation is not available.");
  }
  return result;
};

axiosInterceptor.interceptors.request.use(
  async (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;
    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`;
      const isAllow = await getLocation();
      if (!isAllow) {
        return Promise.reject(new Error("Please Enable Your Location"));
      }
    }

    return config;
  },
  (error) => {
    message.error("Error");
    Promise.reject(error);
  }
);

axiosInterceptor.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let defaultMessage = "PROCESSING ERROR";
    let notificationMessage = defaultMessage;

    if (error?.message === "Please Enable Your Location") {
      message.error("Mohon untuk mengaktifkan lokasi");
      return Promise.reject(error);
    }

    const errorResponse =
      error?.response?.data?.error_message ||
      error?.response?.data?.dataHeader?.message;
    const errorStatus = error?.response?.status;

    if (errorResponse) {
      notificationMessage = errorResponse.toUpperCase();
    } else {
      if (notificationMessageStatus[error?.response?.status]) {
        notificationMessage = notificationMessageStatus[error.response.status];
      }
    }

    if (errorStatus === 401 || errorStatus === 403 || errorStatus === 406) {
      store.dispatch(signOut());
    }

    message.error(notificationMessage);
    return Promise.reject(error);
  }
);

export default axiosInterceptor;
